<template>
  <Toast position="bottom-right">
    <template #message="{ message }">
      <div class="flex-column flex-stretch" @click="handleMessage(message)">
        <b class="font-size-2">
          {{ message.summary }}
        </b>
        <div v-if="typeof message.detail === 'object'">{{ message.detail.content }}</div>
        <div v-else>{{ message.detail }}</div>
      </div>
    </template>
  </Toast>
</template>

<script setup lang="ts">
import { Capacitor } from "@capacitor/core";
import Toast from "primevue/toast";
import { useRouter } from "vue-router";

const router = useRouter();

function handleMessage(message: any) {
  if (typeof message === 'object') {
    if (/^https?:/.test(message.detail.url)) {
      if (Capacitor.getPlatform() === 'web') {
        window.open(message.detail.url, '_blank');
      } else {
        window.open(message.detail.url, '_system');
      }
    } else {
      router.push(message.detail.url);
    }
  }
}
</script>

<style scoped></style>
